// extracted by mini-css-extract-plugin
export default {"filterChips":"filter-chips_filterChips__XMQkZ","chipsList":"filter-chips_chipsList__47MPR","chips":"filter-chips_chips__ZY2bE","clearBtn":"filter-chips_clearBtn__Bza-o"};